import { Chevron } from "@components/icons"
import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import {
  body16MainStyles,
  smallcapsRegular13Styles,
} from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const itemBaseProps = `
  ${body16MainStyles}
  display: flex;
  width: 100%;
  height: auto;
  padding: 14px 10px 14px 20px; // padding: 18px 10px 18px 20px;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  color: ${colors.mediumDarkGray};
  transition: background-color ${animation.medium} ${cubicBezier};
  background-color: ${colors.offWhite};
  border: none;
  border-bottom: solid 1px ${colors.dividerLineGray};
  cursor: pointer;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    transition: background-color ${animation.quick} ${cubicBezier};
    background-color: ${colors.dividerLineGray};
    cursor: pointer;
  }
`

const Tag = styled.div`
  ${smallcapsRegular13Styles}
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 32px;
  height: 16px;
  margin-left: 10px;
  padding-top: 3px;
  border-radius: 2px;
  background-color: ${colors.brandOrange};
  font-size: 11px;
  letter-spacing: 0.5px;
  line-height: 13px;
  color: ${colors.offWhite};
`

export const ItemContainer = styled.div`
  ${itemBaseProps}
`

export const ButtonContainer = styled.button`
  ${itemBaseProps}
`

export const LinkContainer = styled(Link)`
  ${itemBaseProps}
  justify-content: start;
`

export const ExternalLinkContainer = styled.a`
  ${itemBaseProps}
`

export const IconWrapper = styled.div<{ $rotate?: number }>`
  width: 24px;
  height: 24px;
  margin-right: 5px;
  flex-shrink: 0;
  transition: transform ${animation.quick} ${cubicBezier};
  ${({ $rotate }) => $rotate && `transform: rotate(${$rotate}deg);`}
`

export interface MenuItemProps {
  alwaysRenderIcon?: boolean
  external?: boolean
  hideIcon?: boolean
  label: string
  link?: string
  onClick?: () => void
  tag?: string
}

const MenuItem: React.FC<MenuItemProps> = ({
  alwaysRenderIcon,
  external,
  hideIcon,
  label,
  link,
  onClick,
  tag,
}) => {
  if (external && link) {
    return (
      <ExternalLinkContainer href={link} rel="noopener" target="_blank">
        {label}
        {alwaysRenderIcon && (
          <IconWrapper>
            <Chevron strokeColor={colors.mediumDarkGray} />
          </IconWrapper>
        )}
      </ExternalLinkContainer>
    )
  } else if (link) {
    return (
      <LinkContainer onClick={onClick} to={link}>
        {label} {tag && <Tag>{tag}</Tag>}
        {alwaysRenderIcon && (
          <IconWrapper>
            <Chevron strokeColor={colors.mediumDarkGray} />
          </IconWrapper>
        )}
      </LinkContainer>
    )
  }

  return (
    <ButtonContainer onClick={onClick}>
      {label}
      {!hideIcon && (
        <IconWrapper>
          <Chevron strokeColor={colors.mediumDarkGray} />
        </IconWrapper>
      )}
    </ButtonContainer>
  )
}

export default MenuItem
